"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Hero from "@/components/Hero";
import Projects from "@/components/Projects";
import CTA from "@/components/CTA";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

/** Mirrors the Project shape defined in Projects.tsx */
interface Project {
  id?: string;
  title: string;
  description: string;
  tech: string[];
  github: string;
  demo: string;
  images: string[];
}

/** Mirrors ProjectsDictionary defined in Projects.tsx */
interface ProjectsDictionary {
  title: string;
  swipeHint: string;
  viewAll: string;
  hide: string;
  repo: string;
  demo: string;
  offline: string;
  viewGithub: string;
  prev: string;
  next: string;
  pageFormat: string;
  newTab: string;
  list: Project[];
}

/** Full dictionary shape passed down from the locale layout */
interface HomeDict {
  hero: Record<string, string>;
  projects: ProjectsDictionary;
  cta: Record<string, string>;
  contact: Record<string, string>;
  footer: Record<string, string>;
}
export default function HomeClientWrapper(t0) {
  const $ = _c(16);
  const {
    dict
  } = t0;
  let t1;
  if ($[0] !== dict.hero) {
    t1 = <Hero dict={dict.hero} />;
    $[0] = dict.hero;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== dict.projects) {
    t2 = <Projects dict={dict.projects} />;
    $[2] = dict.projects;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== dict.cta) {
    t3 = <CTA dict={dict.cta} />;
    $[4] = dict.cta;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== dict.contact) {
    t4 = <Contact dict={dict.contact} />;
    $[6] = dict.contact;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== dict.footer) {
    t5 = <Footer dict={dict.footer} />;
    $[8] = dict.footer;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <main className="min-h-screen overflow-x-hidden flex flex-col">{t1}{t2}{t3}{t4}{t5}</main>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}